/* 注釈 */
import React from 'react';
import { Row } from 'react-bootstrap';
var Annotation = function (_a) {
    var text = _a.text;
    return React.createElement(Row, { className: "annotation" }, text);
};
export default Annotation;
